<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>사용자 상세 정보 조회</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="goList">사용자 리스트</button>
        </div>
        <div>
          <button class="btn btn-140" @click="deleteUser">
            <span v-if="!processing" class="process">사용자 삭제</span>
            <ButtonLoading v-else></ButtonLoading>
          </button>
        </div>
        <div>
          <button class="btn btn-140" @click="updateUser">사용자 수정</button>
        </div>
        <div>
          <button class="btn btn-140" @click="updaterepresentative">대표 담당자 지정</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div v-if="detailType === 'view'" class="table-content">
        <table>
          <tr>
            <td class="header">사용자 ID</td>
            <td>{{ user.userID }}</td>
          </tr>
          <tr>
            <td class="header">이메일 주소</td>
            <td>{{ user.email }}</td>
          </tr>
          <tr>
            <td class="header">역할</td>
            <td>{{ $getConstName('userRole', user.role) }}</td>
          </tr>
          <tr>
            <td class="header">부서 이름</td>
            <td>{{ user.divisionName }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">사용자 이름</td>
            <td>{{ user.name }}</td>
          </tr>
          <tr>
            <td class="header">핸드폰 번호</td>
            <td>{{ user.mobile }}</td>
          </tr>
          <tr>
            <td class="header">회사 이름</td>
            <td>{{ user.companyName }}</td>
          </tr>
          <tr>
            <td class="header"></td>
            <td></td>
          </tr>
        </table>
      </div>
      <div v-if="detailType === 'edit'" class="table-content">
        <table>
          <tr>
            <td class="header">사용자 ID</td>
            <td>
              <div v-if="user.userID">{{ user.userID }}</div>
              <div v-else><input type="text" v-model="editUser.userID" /></div>
            </td>
          </tr>
          <tr>
            <td class="header">이메일 주소</td>
            <td><input type="text" v-model="editUser.email" /></td>
          </tr>
          <tr>
            <td class="header">역할</td>
            <td>
              <select v-model="editUser.role">
                <option v-for="item in userRole" :key="item.code" :value="item.code">
                  {{ item.name }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">회사 이름</td>
            <td>{{ user.companyName }}</td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">사용자 이름</td>
            <td><input type="text" v-model="editUser.name" /></td>
          </tr>
          <tr>
            <td class="header">핸드폰 번호</td>
            <td><input type="text" v-model="editUser.mobile" /></td>
          </tr>
          <tr>
            <td class="header">비밀번호</td>
            <td><input type="password" v-model="editUser.passwd" /></td>
          </tr>
          <tr>
            <td class="header">부서 이름</td>
            <td>{{ user.divisionName }}</td>
          </tr>
        </table>
      </div>
      <div v-if="detailType === 'edit'" class="table-btn center">
        <button
          class="btn btn-140 btn-blue-line" @click="excuteUpdate">
          <span v-if="!processing" class="process">수정</span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-continue */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'division',
    'user',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    detailType: 'view',
    editUser: null,
    userRole: [],
    processing: false,
  }),
  created() {
    const token = this.$jwtDecode(this.$cookie.get('accessToken'));
    this.scope = token.scope;
    this.role = token.role;

    for (let i = 0; i < this.$userRole.length; i++) {
      if (this.$userRole[i].code === 4) {
        // monitor 는 CS 만 가능
        if (this.division.scope === 1 || this.division.scope === 2) {
          this.userRole.push(this.$userRole[i]);
        }
        continue;
      }

      if (i > 0) {
        this.userRole.push(this.$userRole[i]);
      } else if (i === 0 && this.scope === 1 && this.role === 1 && this.division.scope < 3) {
        this.userRole.push(this.$userRole[i]);
      }
    }
  },
  methods: {
    updateUser() {
      this.editUser = JSON.parse(JSON.stringify(this.user));
      this.detailType = 'edit';
    },
    async excuteUpdate() {
      try {
        this.processing = true;
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/user/${this.user.uID}`;

        if (this.editUser.passwd) {
          const encPass = this.$jsEncrypt.encrypt(this.editUser.passwd);
          this.editUser.passwd = encPass;
        }

        if (this.editUser.role === 1) {
          this.editUser.admin = {
            divisionID: this.user.divisionID,
          };
        } else if (this.editUser.role === 2) {
          this.editUser.manager = {
            divisionID: this.user.divisionID,
          };
        } else if (this.editUser.role === 3) {
          this.editUser.operator = {
            divisionID: this.user.divisionID,
          };
        } else if (this.editUser.role === 4) {
          this.editUser.monitor = {
            divisionID: this.user.divisionID,
          };
        } else {
          alert('"역할"이 올바르지 않습니다.');
          this.processing = false;
          return;
        }

        const param = this.editUser;
        const createResult = await this.$http.put(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        const division = {
          id: this.user.divisionID,
          name: this.user.divisionName,
          alias: this.user.divisionAlias,
          pID: this.user.companyID,
          pName: this.user.companyName,
          pAlias: this.user.companyAlias,
        };

        this.processing = false;
        this.$emit('refreshList', division, 'division', 1);
      } catch (e) {
        this.processing = false;
        console.error(e);
      }
    },
    async updaterepresentative() {
      try {
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${this.user.companyID}`;

        const param = {
          representativeUID: this.user.uID,
        };
        const createResult = await this.$http.put(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }
        alert('대표 담당자로 지정되었습니다.');
      } catch (e) {
        console.error(e);
      }
    },
    cancelUpdate() {
      this.detailType = 'view';
    },
    async deleteUser() {
      this.processing = true;
      const user = await this.$getUser(this.user.uID, true);
      if (!user) {
        alert('존재하지 않는 사용자입니다.');
        this.processing = false;
        return;
      } else if (user.dependence) {
        let c = '';
        if (user.companies) {
          for (let i = 0; i < user.companies.length; i++) {
            if (i !== 0) {
              c += ', ';
            }
            c += user.companies[i].companyName;
          }
        }
        let d = '';
        if (user.devices) {
          for (let i = 0; i < user.devices.length; i++) {
            if (i !== 0) {
              d += ', ';
            }
            d += user.devices[i].deviceName;
          }
        }
        if (c.length > 0 && d.length > 0) {
          alert(`회사 담당자 또는 냉장고를 관리하는 사용자는 삭제할 수 없습니다.\n"계정 관리" 또는 "냉장고 관리"를 확인해 주세요.\n회사: ${c}\n냉장고: ${d}`);
          this.processing = false;
        } else if (c.length > 0) {
          alert(`회사 담당자는 삭제할 수 없습니다.\n"계정 관리"를 확인해 주세요.\n회사: ${c}`);
          this.processing = false;
        } else if (d.length > 0) {
          alert(`냉장고를 관리하는 사용자는 삭제할 수 없습니다.\n"냉장고 관리"를 확인해 주세요.\n냉장고: ${d}`);
          this.processing = false;
        } else {
          alert('회사 담당자 또는 냉장고를 관리하는 사용자는 삭제할 수 없습니다.\n"계정 관리" 또는 "냉장고 관리"를 확인해 주세요.');
          this.processing = false;
        }
        return;
      }

      if (!confirm('정말 삭제하시겠습니까?')) {
        this.processing = false;
        return;
      }

      try {
        const url = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/user/${this.user.uID}`;

        const createResult = await this.$http.delete(url,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        const division = {
          id: this.user.divisionID,
          name: this.user.divisionName,
          alias: this.user.divisionAlias,
          pID: this.user.companyID,
          pName: this.user.companyName,
          pAlias: this.user.companyAlias,
        };

        this.processing = false;
        this.$emit('refreshList', division, 'division', 1);
      } catch (e) {
        if (e.response.status === 403) {
          alert('사용중 입니다.');
        } else {
          console.error(e);
        }
        this.processing = false;
      }
    },
    goList() {
      const division = {
        id: this.user.divisionID,
        name: this.user.divisionName,
        alias: this.user.divisionAlias,
        pID: this.user.companyID,
        pName: this.user.companyName,
        pAlias: this.user.companyAlias,
      };
      this.$emit('refreshList', division, 'division');
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/account/user/UserDetail.vue